import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { portfolioData } from '../data/mock';
import {
  CaseStudyHero,
  StickyNav,
  Overview,
  Challenge,
  Insights,
  Solution,
  Process,
  FinalDesign,
  Impact,
  Learnings,
  NextProject,
} from '../components/CaseStudySections';

const SECTIONS = [
  { id: 'overview', label: 'Overview' },
  { id: 'problem', label: 'Challenge' },
  { id: 'research', label: 'Insights' },
  { id: 'solution', label: 'Solution' },
  { id: 'process', label: 'Process' },
  { id: 'design', label: 'Design' },
  { id: 'outcome', label: 'Impact' },
  { id: 'learnings', label: 'Learnings' },
];

const SCROLL_OFFSET = 180;

const CaseStudy = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('overview');

  const caseStudy = portfolioData.caseStudies.find((cs) => cs.id === id);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [id]);

  const handleScroll = useCallback(() => {
    const scrollPosition = window.scrollY + SCROLL_OFFSET;
    for (const section of SECTIONS) {
      const element = document.getElementById(section.id);
      if (element) {
        const { offsetTop, offsetHeight } = element;
        if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
          setActiveSection(section.id);
          break;
        }
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  if (!caseStudy) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <div className="text-center">
          <h1 className="text-4xl font-heading font-bold mb-4 silver-text">Case Study Not Found</h1>
          <button onClick={() => navigate('/')} className="glass-btn px-6 py-3 rounded-full text-white text-sm">Go Back Home</button>
        </div>
      </div>
    );
  }

  const currentIndex = portfolioData.caseStudies.findIndex((cs) => cs.id === id);
  const nextProject = portfolioData.caseStudies[(currentIndex + 1) % portfolioData.caseStudies.length];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <CaseStudyHero caseStudy={caseStudy} onBack={() => navigate('/')} />
      <StickyNav sections={SECTIONS} activeSection={activeSection} onNavigate={scrollToSection} />

      <div className="max-w-5xl mx-auto px-6 lg:px-12 py-20">
        <Overview caseStudy={caseStudy} />
        <Challenge caseStudy={caseStudy} />
        <Insights caseStudy={caseStudy} />
        <Solution caseStudy={caseStudy} />
        <Process caseStudy={caseStudy} />
        <FinalDesign caseStudy={caseStudy} />
        <Impact caseStudy={caseStudy} />
        <Learnings caseStudy={caseStudy} />
      </div>

      <NextProject nextProject={nextProject} />
    </div>
  );
};

export default CaseStudy;
